/**
 * Labstep
 *
 * @module components/Resource/OrderRequestTemplate/EmptyState
 * @desc Empty State for OrderRequestTemplate
 */

import OrderRequestTemplateActionCreate from 'labstep-web/components/OrderRequestTemplate/Action/Create';
import { OrderRequestTemplateActionDelete } from 'labstep-web/components/OrderRequestTemplate/Action/Delete';
import { CardEmptyState } from 'labstep-web/core/Card/EmptyState';
import type React from 'react';
import type { ResourceOrderRequestTemplateEmptyStateProps } from './types';

export const ResourceOrderRequestTemplateEmptyState: React.FC<
  ResourceOrderRequestTemplateEmptyStateProps
> = ({ resource }) => {
  const title = 'No Order Request Template';

  const explanation =
    'Order request templates allow each request to be initialised with a default price.';

  return (
    <CardEmptyState
      title={title}
      explanation={explanation}
      src="/img/empty-state/orderRequests.svg"
      action={
        resource.order_request_template ? (
          <OrderRequestTemplateActionDelete
            orderRequestTemplate={resource.order_request_template}
          />
        ) : (
          <OrderRequestTemplateActionCreate resource={resource} />
        )
      }
    />
  );
};
